
/*
Defines the custom element <ravel-emoji-grid>
*/

import { RavelEmojiGrid } from './src/RavelEmojiGrid.js';

customElements.define('ravel-emoji-grid', RavelEmojiGrid);
